<div>
  <!-- User MLP Table -->
  <p-table #table [scrollable]="true" scrollHeight="flex" [value]="userMlpList()" [loading]="loading()"
    [paginator]="true" [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]"
    currentPageReportTemplate="{first}-{last} of {totalRecords}" [stripedRows]="true">
    <!-- Table Caption with Search, Add and Import Buttons -->
    <ng-template pTemplate="caption">
      <div class="flex flex-col md:flex-row gap-3 md:gap-2">
        <div class="flex gap-2">
          <p-button label="{{ 'userMlp.addUserMlp' | translate }}" icon="pi pi-plus" severity="success"
            [disabled]="loading()" [loading]="loading()" (onClick)="openCreateDialog()">
          </p-button>
          <p-button label="{{ 'userMlp.importCsv' | translate }}" icon="pi pi-upload" severity="secondary"
            [disabled]="loading() || importLoading()" [loading]="importLoading()" (onClick)="openCsvImport()">
          </p-button>
          <!-- Hidden file input for CSV import -->
          <input #csvFileInput type="file" accept=".csv,text/csv" class="hidden" (change)="onCsvFileSelect($event)" />
        </div>
        <p-iconfield iconPosition="left" class="md:ml-auto w-full md:w-auto">
          <p-inputicon>
            <i class="pi pi-search"></i>
          </p-inputicon>
          <input #searchInput pInputText type="text" [formControl]="searchControl"
            [placeholder]="'userMlp.searchPlaceholder' | translate" class="w-full" />
        </p-iconfield>
      </div>
    </ng-template>

    <!-- Table Header -->
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width: 250px">{{ 'userMlp.headers.walletAddress' | translate }}</th>
        <th style="min-width: 150px">{{ 'userMlp.headers.mlpAmount' | translate }}</th>
        <th style="min-width: 150px">{{ 'userMlp.headers.actions' | translate }}</th>
      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-userMlp>
      <tr>
        <td style="min-width: 250px">
          <span [pTooltip]="userMlp.walletAddress" tooltipPosition="top" class="cursor-help font-mono">
            {{ userMlp.walletAddress | shortenAddress }}
          </span>
        </td>
        <td style="min-width: 150px">{{ userMlp.mlpAmount | number }}</td>
        <td style="min-width: 150px" class="py-2">
          <div class="flex gap-2">
            <p-button icon="pi pi-pencil" [rounded]="true" size="small" [disabled]="loading()"
              [ariaLabel]="'userMlp.edit' | translate" (onClick)="openEditDialog(userMlp)">
            </p-button>
            <p-button icon="pi pi-trash" [rounded]="true" size="small" [disabled]="loading()"
              [ariaLabel]="'userMlp.delete' | translate" (onClick)="deleteUserMlp(userMlp)">
            </p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- Empty state -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3" class="text-center py-8">
          <div class="flex flex-col items-center gap-3">
            <i class="pi pi-wallet text-4xl text-muted"></i>
            <p class="text-body-md text-muted">{{ 'userMlp.noData' | translate }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Create/Edit Dialog -->
  <p-dialog [header]="getDialogTitle()" [(visible)]="dialogVisible" [modal]="true" [style]="{ width: '500px' }"
    [draggable]="false" [resizable]="false">
    <form [formGroup]="userMlpForm" (ngSubmit)="saveUserMlp()">
      <!-- Wallet Address Field -->
      <div class="mb-4">
        <label for="walletAddress" class="block mb-2">
          {{ 'userMlp.form.walletAddress' | translate }} *
        </label>
        <input id="walletAddress" type="text" pInputText formControlName="walletAddress"
          [class.ng-invalid]="isFieldInvalid('walletAddress')" [class.ng-dirty]="isFieldInvalid('walletAddress')"
          class="w-full font-mono" [placeholder]="'userMlp.form.walletAddressPlaceholder' | translate" />
        @if (isFieldInvalid('walletAddress')) {
        <p-message severity="error">
          {{ getFieldError('walletAddress') }}
        </p-message>
        }
        <small class="block mt-1 text-muted">
          {{ 'userMlp.form.walletAddressHint' | translate }}
        </small>
      </div>

      <!-- MLP Amount Field -->
      <div class="mb-4">
        <label for="mlpAmount" class="block mb-2">
          {{ 'userMlp.form.mlpAmount' | translate }} *
        </label>
        <p-inputNumber id="mlpAmount" formControlName="mlpAmount" [useGrouping]="true" [min]="0"
          [class.ng-invalid]="isFieldInvalid('mlpAmount')" [class.ng-dirty]="isFieldInvalid('mlpAmount')"
          styleClass="w-full" [placeholder]="'userMlp.form.mlpAmountPlaceholder' | translate"></p-inputNumber>
        @if (isFieldInvalid('mlpAmount')) {
        <p-message severity="error">
          {{ getFieldError('mlpAmount') }}
        </p-message>
        }
      </div>

      <!-- Dialog Footer -->
      <div class="flex justify-end gap-2 mt-6">
        <p-button label="{{ 'common.cancel' | translate }}" severity="secondary" (onClick)="dialogVisible.set(false)"
          [disabled]="loading()">
        </p-button>
        <p-button label="{{ 'common.save' | translate }}" type="submit" [disabled]="loading() || userMlpForm.invalid"
          [loading]="loading()">
        </p-button>
      </div>
    </form>
  </p-dialog>

  <!-- Confirmation Dialog -->
  <p-confirmDialog></p-confirmDialog>
</div>
